
export const oddsFormatMap = {
  american: "a",
  decimal: "d",
  fraction: "f",
  a: "a",
  d: "d",
  f: "f",
};
